import React from 'react'
import '../../styles/content/content.css'
import { useTranslation } from 'react-i18next'

function Switcher({ setSwitcher = () => {}, switcher = false, size = 16, showText = true, disabled = false, id = '' }) {
    const { t } = useTranslation()

    return (
        <button
            type="button"
            role="switch"
            aria-checked={!!switcher}
            className={`flex flex-row justify-between items-center min-w-[75px] gap-[5px] ${!disabled ? 'pointer ' : ''}`}
            onClick={() => setSwitcher(!switcher)}
            disabled={disabled}
            id={id}
        >
            {showText && <div className={`font-semibold text-lg switch-label ${switcher ? 'text-[#5E639B]' : 'text-mudPurple'}`}>{switcher ? t('on') : t('off')}</div>}
            <div className={`rounded-full min-w-[40px] p-1 flex flex-row items-center switch-track switcher-animation ${switcher ? 'bg-deepPurple' : 'bg-deselectPurple'}`}>
                <div className={`min-w-[16px] w-[16px] h-[16px] rounded-full switch-knob ${switcher ? 'bg-highlightColor' : 'bg-white'}`} data-on={!!switcher} />
            </div>
        </button>
    )
}

export default Switcher
